import React from 'react'
import LoginModalConfirm from './LoginModalConfirm'
import LoginPanel from '../../../login/components/LoginPanel'
import { LoginProvider } from '../../../login/contexts/LoginContext'

export interface LoginModalHandle {
    show: () => void,
    hide: () => void
}

type Props = {
    message: string,
    onComplete: Function
}

const LoginModal = React.forwardRef<LoginModalHandle, Props>((props, ref) => {
    const { message, onComplete } : Props = props;
    const dialogRef = React.useRef<HTMLDialogElement>(null);
    const [page, setPage] = React.useState('confirm');

    React.useImperativeHandle(ref, () => ({
        show() {
            dialogref.current!.showModal();
        },
        hide() {
            dialogref.current!.close();
            setPage('confirm');
        }
    })) 

    const hideModal = (): void => {
        //deferring to allow document level click actions
        //to detect clicked element before it is destroyed
        setTimeout(() => {
            dialogref.current!.close();
            setPage('confirm');
        }, 0)
    }

    const goToLogin = (): void => {
        setTimeout(() => {
            setPage('login');
        }, 0)
    }

    const handleLoginComplete = (): void => {
        onComplete();
    }

    const content = () => {
        switch(page){
            case 'confirm':
                return <LoginModalConfirm message={message} onCancel={hideModal} onConfirm={goToLogin} />
            case 'login':
                return <LoginPanel useExternalButtons={false} onComplete={handleLoginComplete} />
            default:
                return <LoginModalConfirm message={message} onCancel={hideModal} onConfirm={goToLogin} />
        }
    }

    return (
        <dialog ref={dialogRef} className='login-modal'>
            <LoginProvider>
                {content()}
            </LoginProvider>
        </dialog>
    )
})

export default LoginModal;